module.exports = __webpack_public_path__ + "img/c1.a6040e7.png";